import {NinchatAttributes} from '../../../api/types'
import React from 'react'
import UserAvatar from '../../Avatar/UserAvatar'
import {isPropsObjectEqual} from 'utils/props'

const SidebarUserView = ({
    hasActivity,
    userConnected,
    userIconUrl,
    label,
    userName,
    userIdle,
}: {
    hasActivity: boolean,
    userIdle: NinchatAttributes.NinchatUserAttributes['idle'],
    userConnected: NinchatAttributes.NinchatUserAttributes['connected'],
    label?: string,
    userName: NinchatAttributes.NinchatUserAttributes['name'],
    userIconUrl: NinchatAttributes.NinchatUserAttributes['iconurl'],

}) => (
    <>
        <UserAvatar
            connected={userConnected}
            highlight={hasActivity}
            idle={Boolean(userIdle)}
            name={userName}
            size='small'
            src={userIconUrl}
        />
        <span>{label}</span>
    </>
)

SidebarUserView.defaultProps = {label: ''}

export default React.memo(SidebarUserView, isPropsObjectEqual)
